// extracted by mini-css-extract-plugin
export default {"formsProgressPopupContent":"MedicalNote_formsProgressPopupContent__IcCRs","loadingSpinner":"MedicalNote_loadingSpinner__RDkDj"};